import React, { useState, useRef, useEffect } from 'react';
import '../multiSelect/_multiSelect.scss';

function SingleSelect({ options, value, onChange, placeholder = 'Select...', isDisabled = false, onSearchChange, searchable = true }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);

  // Filter options based on search (only if no external search callback)
  const filteredOptions = onSearchChange ? options : (options?.filter(option =>
    option.label.toLowerCase().includes(search.toLowerCase())
  ));

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options?.find(opt => opt.value === value);

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
    setSearch('');
  };

  const handleSearchChange = (e) => {
    const newSearch = e.target.value;
    setSearch(newSearch);
    if (onSearchChange) {
      onSearchChange(newSearch);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    onChange('');
  };

  return (
    <div className={`multi-select-container${isDisabled ? ' disabled' : ''}`} ref={containerRef}>
      <div
        className={`multi-select-control${isOpen ? ' open' : ''}`}
        onClick={() => !isDisabled && setIsOpen(!isOpen)}
        tabIndex={0}
      >
        <div className="multi-select-tags">
          {!selectedOption && <span className="multi-select-placeholder">{placeholder}</span>}
          {selectedOption && (
            <span className="multi-select-tag" key={selectedOption.value}>
                  {/*{`${selectedOption.value} - ${selectedOption.label}`}*/}
              {selectedOption.label}
              <button
                type="button"
                className="multi-select-remove"
                onClick={handleClear}
                aria-label={`Remove ${selectedOption.label}`}
              >
                ×
              </button>
            </span>
          )}
        </div>
        <span className="multi-select-arrow">▼</span>
      </div>
      {isOpen && !isDisabled && (
        <div className="multi-select-dropdown">
          {searchable && (
            <input
              className="multi-select-search"
              type="text"
              value={search}
              onChange={handleSearchChange}
              placeholder="Search..."
              autoFocus
            />
          )}
          <div className="multi-select-options">
            {filteredOptions.length === 0 ? (
              <div className="multi-select-no-options">No options</div>
            ) : (
              filteredOptions.map(option => (
                <div
                  key={option.value}
                  className={`multi-select-option${selectedOption && selectedOption.value === option.value ? ' selected' : ''}`}
                  onClick={() => handleSelect(option)}
                >
                  {/*{`${option.value} - ${option.label}`}*/}
                  {option.label}
                  {selectedOption && selectedOption.value === option.value && <span className="multi-select-check">✔</span>}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SingleSelect;